import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  events: [],
  selectedEvent: null,
  error: null,
  loading: false,
  eventEntered: false,
};

const getEventsStart = (state, action) => {
  return updateObject(state, { error: null, loading: true });
};

const selectEvent = (state, action) => {
  return updateObject(state, {
    selectedEvent: action.selectedEvent,
    error: null,
    loading: false,
  });
};

const getEventEntered = (state, action) => {
  return updateObject(state, {
    eventEntered: action.eventEntered,
    error: null,
    loading: false,
  });
};

const getEventEnteredClear = (state) => {
  return updateObject(state, {
    eventEntered: null,
    error: null,
    loading: false,
  });
};

const getEventSuccess = (state, action) => {
  return updateObject(state, {
    events: action.events,
    error: null,
    loading: false,
  });
};

const getEventsFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_EVENTS_START:
      return getEventsStart(state, action);
    case actionTypes.GET_EVENTS_SUCCESS:
      return getEventSuccess(state, action);
    case actionTypes.GET_EVENTS_FAIL:
      return getEventsFail(state, action);
    case actionTypes.SELECT_EVENT:
      return selectEvent(state, action);
    case actionTypes.EVENT_ENTERED:
      return getEventEntered(state, action);
    case actionTypes.EVENT_ENTERED_CLEARED:
      return getEventEnteredClear(state);
    default:
      return state;
  }
};

export default reducer;
